import { Lightbulb02 } from '@untitledui/icons';
import type { ComponentType, ReactNode, SVGAttributes } from 'react';

interface ProposalInfoCalloutProps {
  children: ReactNode;
  /** Icon component to display. Defaults to Lightbulb02. */
  icon?: ComponentType<SVGAttributes<SVGElement>>;
  className?: string;
}

/**
 * Consistent info callout for proposal renderers.
 * Small, blue-tinted with an icon and text.
 */
export function ProposalInfoCallout({
  children,
  icon: Icon = Lightbulb02,
  className = '',
}: ProposalInfoCalloutProps) {
  return (
    <div
      className={`flex items-start gap-2.5 px-3.5 py-2.5 rounded-lg border ${className}`}
      style={{
        backgroundColor: 'var(--color-utility-blue-light-50)',
        borderColor: 'var(--color-utility-blue-light-200)',
      }}
    >
      <Icon
        className='w-4 h-4 shrink-0 mt-0.5'
        style={{ color: 'var(--color-utility-blue-light-700)' }}
        aria-hidden='true'
      />
      <div
        className='text-sm leading-relaxed'
        style={{ color: 'var(--color-utility-blue-light-700)' }}
      >
        {children}
      </div>
    </div>
  );
}
